import { Ellipse } from "@react-pdf/renderer";
import Helper from "../functions/Helper.js";
import tinycolor from "tinycolor2";

export default function PdfCircle(props) {
  let { x, y, rx, ry } = Helper.convertEllipseToSVG(
    props.pos[0],
    props.pos[1],
    props.rx,
    props.ry,
    props.court.full
  );

  let color = tinycolor(props.backgroundColor);
  let alpha = color.getAlpha();
  let hex = color.toHexString();

  return (
    <Ellipse cx={x} cy={y} fill={hex} fillOpacity={alpha} rx={rx} ry={ry} />
  );
}
